import { render, staticRenderFns } from "./UnionIndex.vue?vue&type=template&id=345289ad&"
import script from "./UnionIndex.vue?vue&type=script&lang=js&"
export * from "./UnionIndex.vue?vue&type=script&lang=js&"
import style0 from "./UnionIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports